import React, { useRef, useState, useEffect, useMemo } from "react";
import {
  APMCsByDistrict,
  ItemsSponsor,
  sponsorRegistration,
} from "../../../../../core/data/json/contractFarming"; // import your JSON file
import CommonSelect from "./commonSelect";
// import { DistrictOptionsAPMC } from "../../../../../core/data/json/contractFarming";
import { DatePicker } from "antd";
import Select from "react-select";
// import CreatableSelect from "react-select/creatable";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { apmcByDistrictId, getAllSpices, getOneContractFarmingDetails, SponsorRegistration, submitContractFarmingFiles } from "../../../../auth/services/privateapicalling";
import { Link, useNavigate } from "react-router-dom";
import { getAllAPMC } from "../../../../auth/services/apiCalling";

interface SponsorReg {
  onNext: (paymentData) => void;

  applicationId: any;
  couchId:any;
  canOnlyView?: boolean;
}

const SponsorRegistrationP1 = ({ onNext, applicationId,couchId, canOnlyView }: SponsorReg) => {
  // const [date, setDate] = useState("");
  const token = useSelector((state: any) => state.auth.token);
  const [formData, setFormData] = useState({
    name: "",
    address: "",
    phone: "",
    fromDate: "",
    toDate: "",
    years: "",
    solvencyCertificate: null as any,
    bankGuarantee: null as any,
    firmNgoCoopCoopDetails: null as any,
    agriculturalProduceDetails: "",
    challanCopy: null as any,
    licenseProof: null as any,
    e_Hastakshar: null as any,
    remarks: "",
  });



  const userDetail = useSelector((state: any) => state.auth.userDetails);
  const roleIdentifier = userDetail?.Role?.Role_Identifier;
  const [statusLvl, setStatusLvl] = useState("")

  const navigate = useNavigate();
  const [iscommentOpen, setIscommentOpen] = useState(false);
  const [districtOptions , setDistrictOptions] = useState<any[]>([]);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [organizationType, setOrganizationType] = useState("");
  const organizationTypeOptions = [
  { value: "Company", label: "Company" },
  { value: "Partnership Firm", label: "Partnership Firm" },
  { value: "Non-Governmental Organization", label: "Non-Governmental Organization" },
  { value: "Co-operative Society", label: "Co-operative Society" },
  { value: "Government Organization", label: "Government Organization" }
];

  //--------------------------Table data final amount------------------------------
  const [isFruitsSelected, setIsFruitsSelected] = useState(false);
  const [selectedOthersCount, setSelectedOthersCount] = useState(0);
  const [fruitsSelection, setFruitsSelection] = useState<{
    [key: string]: boolean;
  }>({});

  const anyFruitsSelected = Object.values(fruitsSelection).some(Boolean);
  const fruitsFee = anyFruitsSelected ? 500 : 0;
  const othersFee = selectedOthersCount * 500;
  const totalFee = fruitsFee + othersFee;
  const showFeeSummary = anyFruitsSelected || selectedOthersCount > 0;
const [uploadLoading, setUploadLoading]=useState(false);
  const [spicesOptions, setSpicesOptions] = useState([]);
  const [options, setOptions] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [selectedAPMCs, setSelectedAPMCs] = useState([]);
  const [otherInputs, setOtherInputs] = useState({}); // store creatable select values per APMC
  const [selectedDistricts, setSelectedDistricts] = useState<any[]>([]);
  const [selectedIngredients, setSelectedIngredients] = useState<any[]>([]);
  const [apmcData,setApmcData] = useState([])
  const [commodityData, setCommodityData] = useState([]);
  const [rejectFile, setRejectFile] = useState<File | null>(null);



  
    // ✅ Function to populate form with API data
    const populateFormData = (apiData: any) => {
      
      
      // Populate uploaded documents
      if (apiData.uploadedDoc) {
        const docs = apiData.uploadedDoc;
        const docFields = {
          solvencyCertificate: docs.solvencyCertificate?.data || null,
          bankGuarantee: docs.bankGuarantee?.data || null,
          firmNgoCoopCoopDetails: docs.firmNgoCoopCoopDetails?.data || null,
          challanCopy: docs.challanCopy?.data || null,
          licenseProof: docs.licenseProof?.data || null,
        };
  
        setFormData((prev) => ({
          ...prev,
            name: apiData?.Sponsor_Name,
            address: apiData?.Sponsor_Address,
            phone: apiData?.Sponsor_Phone,
            fromDate: apiData?.Sponsor_Reg_From,
            toDate: apiData?.Sponsor_Reg_To,
            years: apiData?.Sponsor_Reg_Year,
            agriculturalProduceDetails: apiData?.Det_Agriculture_Prod
            ? apiData.Det_Agriculture_Prod.split(",").map((item) => item.trim())
            : [],
          ...docFields,
        }));
        if (docs.firmNgoCoopCoopDetails?.data?.documentName) {
      const docName = docs.firmNgoCoopCoopDetails.data.documentName;
      
      // Check if documentName is one of our organization types
      const isValidOrgType = organizationTypeOptions.some(opt => opt.value === docName);
      
      if (isValidOrgType) {
        setOrganizationType(docName);
      } else if (docName === "firmNgoCoopCoopDetails") {
        // Old data format - don't set organization type, user needs to select
        setOrganizationType("");
      } else {
        // Unknown format - set it anyway in case it's a valid custom value
        setOrganizationType(docName);
      }
    }
      }

     

        if (apiData?.Det_Agriculture_Prod) {
          const ingredientsArray = apiData.Det_Agriculture_Prod
            .split(",")
            .map((item) => item.trim())
            .map((item) => ({
              value: item,
              label: item
            }));
          
          setSelectedIngredients(ingredientsArray);
        }
        
      // Populate commodity data (APMCs, fruits, others)
      if (apiData?.commodityRegsBySponsorRegNo?.length > 0) {
        const commodities = apiData.commodityRegsBySponsorRegNo;
        
        // Set selected districts
        const uniqueDistricts = Array.from(
          new Set(commodities.map((c) => c.district_id))
        );
        const districtData = uniqueDistricts.map((distId) => {
          const commodity = commodities.find((c) => c.district_id === distId);
          return {
            value: distId,
            label: commodity?.departmentDetailsByApmc?.District || "",
          };
        });
        setSelectedDistricts(districtData);
  
        // Fetch APMCs for selected districts
        const districtIds = districtData.map((d) => d.value);
        if (districtIds.length > 0) {
          fetchApmcId(districtIds);
        }

        // Set selected APMCs - will be set after fetchApmcId completes
        setTimeout(() => {
          const apmcDataToSet = commodities.map((c) => ({
            value: c.apmcId,
            label: c.departmentDetailsByApmc?.apmcName || "",
            other: c.departmentDetailsByApmc,
          }));
          setSelectedAPMCs(apmcDataToSet);
        }, 500);
  
        // Set fruits selection
        const fruitsSelectionData = {};
        commodities.forEach((c) => {
          if (c.fruitsAndVeg) {
            fruitsSelectionData[c.apmcId] = true;
          }
        });
        setFruitsSelection(fruitsSelectionData);
  
  
        const othersData = {};
        let othersCount = 0;
        commodities.forEach((c) => {
          if (c.Others && c.Others_Name?.length > 0) {
            othersData[c.apmcId] = c.Others_Name.map((name) => ({
              label: name,
              value: name,
            }));
            othersCount++;
          }
        });
        setOtherInputs(othersData);
        setSelectedOthersCount(othersCount);
  
        // Set commodity data
        setCommodityData(
          commodities.map((c) => ({
            apmcId: c.apmcId,
            district_id: c.district_id,
            fruitsAndVeg: c.fruitsAndVeg,
            Others: c.Others,
            Others_Name: c.Others_Name || [],
          }))
        );
      }
    };
    
    // ✅ Function to fetch application data
    const fetchApplicationData = async (applicationId: string) => {
      try {
        const result = await getOneContractFarmingDetails(applicationId, token);
        
       
        
        if (result.success && result.data) {
          populateFormData(result?.data);
          setStatusLvl(result?.data?.status)
        
        } else {
          toast.warning("No previous data found", { position: "top-right" });
        }
      } catch (error) {
       
        toast.error("Failed to load application data", { position: "top-right" });
      }
    };

    const fetchDistrict =async()=>{
      try {
        const response = await getAllAPMC(token , '' , '');
        const districts = response.data.map((d) => ({
          label: d.District,
          value: d.district_id,
        }));
  
        setDistrictOptions(districts);
  
      } catch (error) {
        toast.error('Internal Server Error')
      }
    }

    useEffect(() => {
  getAllSpices(token)
    .then((data) => {
   
      const formatted = data.data.map(item => ({
        value: item.id,
        label: item.Spices,
      }));
     
      setSpicesOptions(formatted);
    })
    .catch();
}, []);

  useEffect(() => {
    fetchDistrict();

    // Fetch application data if applicationId exists
    if (applicationId) {
      fetchApplicationData(applicationId);
    }
  }, [applicationId]);


  // const handleOtherCheckbox = (apmcValue: string, checked: boolean) => {
  //   const updatedInputs = { ...otherInputs };

  //   if (checked) {
  //     updatedInputs[apmcValue] = updatedInputs[apmcValue] || []; // Ensure it’s an array if newly checked
  //   } else {
  //     delete updatedInputs[apmcValue]; // Remove if unchecked
  //   }

  //   setOtherInputs(updatedInputs);

  //   // ✅ Update count dynamically
  //   const count = Object.keys(updatedInputs).length;
  //   setSelectedOthersCount(count);
  // };

  // Function to calculate text width and adjust input width
  const adjustInputWidth = (text: string, minWidth: number = 200) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    if (context) {
      context.font = "1.25rem Arial"; // Match your font size
      const textWidth = context.measureText(text).width;
      return Math.max(minWidth, textWidth + 10); // Add padding
    }
    return minWidth;
  };



  // useEffect after your other useEffect hooks
useEffect(() => {
  const currentAPMCValues = selectedAPMCs.map(apmc => apmc.value);
  
  setFruitsSelection(prev => {
    const updated = { ...prev };
    Object.keys(updated).forEach(key => {
      if (!currentAPMCValues.includes(key)) {
        delete updated[key];
      }
    });
    return updated;
  });
  
  setOtherInputs(prev => {
    const updated = { ...prev };
    Object.keys(updated).forEach(key => {
      if (!currentAPMCValues.includes(key)) {
        delete updated[key];
      }
    });
    
    // ✅ NEW: Sync ingredients after cleanup
    syncIngredientsFromOthers(updated);
    
    return updated;
  });

  const newCount = Object.keys(
    Object.fromEntries(
      Object.entries(otherInputs).filter(([key]) => currentAPMCValues.includes(key))
    )
  ).length;
  setSelectedOthersCount(newCount);
  
  setCommodityData(prev => 
    prev.filter(item => currentAPMCValues.includes(item.apmcId))
  );
  
}, [selectedAPMCs]);

useEffect(() => {
  // Get current APMC values
  const currentAPMCValues = selectedAPMCs.map(apmc => apmc.value);
  
  // Clean up fruitsSelection
  setFruitsSelection(prev => {
    const updated = { ...prev };
    Object.keys(updated).forEach(key => {
      if (!currentAPMCValues.includes(key)) {
        delete updated[key];
      }
    });
    return updated;
  });
  
  // Clean up otherInputs
  setOtherInputs(prev => {
    const updated = { ...prev };
    Object.keys(updated).forEach(key => {
      if (!currentAPMCValues.includes(key)) {
        delete updated[key];
      }
    });
    return updated;
  });

  // Update selectedOthersCount
  const newCount = Object.keys(
    Object.fromEntries(
      Object.entries(otherInputs).filter(([key]) => currentAPMCValues.includes(key))
    )
  ).length;
  setSelectedOthersCount(newCount);
  
  // Clean up commodityData
  setCommodityData(prev => 
    prev.filter(item => currentAPMCValues.includes(item.apmcId))
  );
  
}, [selectedAPMCs]);
 

  // const editHandler = () => {
  //   if (isDisabled) {
  //     setIsDisabled(false);
  //     toast.success("You Can Edit the Form", { position: "top-right" });
  //   } else {
  //     setIsDisabled(true);
  //     toast.warning("Form Disabled", { position: "top-right" });
  //   }
  // };


  const onCommentClick = () => {
    if (iscommentOpen) {
      setIscommentOpen(false);
      toast.warning("Comment Box Closed", { position: "top-right" });
    } else {
      setIscommentOpen(true);
      toast.success("Comment Box Opened", { position: "top-right" });
    }
  };
const fetchApmcId=async(data:any)=>{
  if (!data || data.length === 0) {
    setApmcData([]); // ✅ Clear when no districts selected
    return;
  }

  const payload={
    // districtIds:selectedDistricts.map(item => item.value)
    districtIds:data
  };
  try{
    const res=await apmcByDistrictId(payload,token)
   

   let newData =  res.data.map((item: any) => ({
     value: item.id,
     label: item.apmcName,
     other: {
        ...item, // Keep all original data
        district_id: item.district_id // Explicitly ensure district_id is accessible
      }
   }));


    setApmcData(newData)
    
  }catch(error){
   
    setApmcData([]);
  }
}


 
const handleDistrictChange = (selected: any) => {
  if (!selected || selected.length === 0) {
    // Clear everything
    setSelectedDistricts([]);
    setSelectedAPMCs([]);
    setApmcData([]); // ✅ Clear APMC options
    fetchApmcId([]);
    return;
  }

  const isSelectAll = selected.some((opt: any) => opt.value === "select_all");

  if (isSelectAll) {
    if (selectedDistricts.length === districtOptions.length) {
      // ✅ Already all selected → deselect everything
      setSelectedDistricts([]);
      setSelectedAPMCs([]);
      setApmcData([]); // ✅ Clear APMC options
      fetchApmcId([]);
    } else {
      // ✅ Select everything
      const allDistricts = [...districtOptions];
      setSelectedDistricts(allDistricts);
      const dataArr = allDistricts.map((item) => item.value);
      fetchApmcId(dataArr);
    }
  } else {
    // ✅ NEW LOGIC: Filter APMCs and APMC options from removed districts
    const newDistrictIds = selected.map((item: any) => item.value);
    const previousDistrictIds = selectedDistricts.map((item: any) => item.value);
    
    // Find removed districts
    const removedDistrictIds = previousDistrictIds.filter(
      id => !newDistrictIds.includes(id)
    );
    
    // Filter out APMCs belonging to removed districts
    if (removedDistrictIds.length > 0) {
      const filteredAPMCs = selectedAPMCs.filter(apmc => 
        !removedDistrictIds.includes(apmc.other?.district_id)
      );
      setSelectedAPMCs(filteredAPMCs);
      
      // ✅ Also filter apmcData to remove options from removed districts
      const filteredApmcData = apmcData.filter((apmc: any) => 
        !removedDistrictIds.includes(apmc.other?.district_id)
      );
      setApmcData(filteredApmcData);
    }
    
    setSelectedDistricts(selected);
    fetchApmcId(newDistrictIds);
  }
};


 
  const handleIngredientsChange = (selected: any) => {
    if (!selected) {
      setSelectedIngredients([]);
      return;
    }

    const isSelectAll = selected.some((opt: any) => opt.value === "select_all");

    if (isSelectAll) {
      // If "Select All" is chosen, select everything
      setSelectedIngredients(ItemsSponsor.options);
    } else {
      setSelectedIngredients(selected);
    }
    // ✅ Clear error when user selects
    if (errors.ingredients && selected && selected.length > 0) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors.ingredients;
        return newErrors;
      });
    }
  };
  const apmcOptionsWithSelectAll = useMemo(() => {
  return [
    { value: "select_all", label: "Select All APMCs" },
    ...apmcData, // whatever comes from your API
  ];
}, [apmcData]);

// --------------------------------------------TO USE SELECT ALL IN APMC------------------------------------------

// const handleAPMCChange = (selected: any) => {
//   if (!selected || selected.length === 0) {
//     setSelectedAPMCs([]);
//     return;
//   }

//   const isSelectAll = selected.some((opt: any) => opt.value === "select_all");

//   if (isSelectAll) {
//     if (selectedAPMCs.length === apmcData.length) {
//       // ✅ Already all selected → deselect everything
//       setSelectedAPMCs([]);
//     } else {
//       // ✅ Select everything (ignore "select_all" itself)
//       const allAPMCs = [...apmcData];
//       setSelectedAPMCs(allAPMCs);
//     }
//   } else {
//     // Normal selection
//     setSelectedAPMCs(selected);
//   }

//   // ✅ Clear error if any valid selection
//   if (errors.apmcs && selected && selected.length > 0) {
//     setErrors((prev) => {
//       const newErrors = { ...prev };
//       delete newErrors.apmcs;
//       return newErrors;
//     });
//   }
// };

  const handleAPMCChange = (selected) => {
    setSelectedAPMCs(selected || []);

    // ✅ Clear error when user selects
    if (errors.apmcs && selected && selected.length > 0) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors.apmcs;
        return newErrors;
      });
    }


  };

const handleOtherSelectChange = (apmc, newValue) => {
  const apmcId = apmc.value;

  setOtherInputs((prev) => {
    const updated = { ...prev, [apmcId]: newValue };

    // ✅ Keep commodity data in sync too
    updateCommodityData(
      apmcId,
      apmc?.other?.district_id,
      fruitsSelection[apmcId],
      newValue
    );

    // ✅ NEW: Sync with selectedIngredients
    syncIngredientsFromOthers(updated);

    return updated;
  });
};

// Helper function to sync selectedIngredients with all Others selections
const syncIngredientsFromOthers = (currentOtherInputs: any) => {
  // Collect all unique crops from all APMCs' Others selections
  const allSelectedCrops = new Set();
  
  Object.values(currentOtherInputs).forEach((crops: any) => {
    if (Array.isArray(crops)) {
      crops.forEach((crop) => {
        allSelectedCrops.add(JSON.stringify({ value: crop.value, label: crop.label }));
      });
    }
  });
  
  // Convert back to array of objects
  const uniqueCrops = Array.from(allSelectedCrops).map((item: any) => JSON.parse(item));
  
  setSelectedIngredients(uniqueCrops);
};

  const handleCreateOption = (apmc, inputValue) => {
    const newOption = { label: inputValue, value: inputValue };
    setOtherInputs((prev) => ({
      ...prev,
      [apmc]: [...(prev[apmc] || []), newOption],
    }));
  };



  const optionsWithSelectAll = useMemo(() => {
    return [
      { value: "select_all", label: "Select All Districts" },
      ...districtOptions,
    ];
  }, [districtOptions]);

  const optionsWithSelectAllinItems = useMemo(() => {
    return [
      { value: "select_all", label: "Select All Items" },
      ...ItemsSponsor.options,
    ];
  }, [ItemsSponsor.options]);

  const handleInputChange = (field: string, value: string) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    errors[field] = "";
  };

  const handleDateChange = (field: "fromDate" | "toDate", value: string) => {
    let updatedForm = { ...formData, [field]: value };
    const { fromDate, toDate } = updatedForm;

    if (fromDate && toDate) {
      const start = new Date(fromDate);
      const end = new Date(toDate);

      if (end >= start) {
        // Calculate difference in years
        let diffYears = end.getFullYear() - start.getFullYear();

        // Adjust if end month/day is before start month/day
        if (
          end.getMonth() < start.getMonth() ||
          (end.getMonth() === start.getMonth() &&
            end.getDate() < start.getDate())
        ) {
          diffYears--;
        }

        updatedForm.years = diffYears.toString();
      } else {
        toast.error("End date must be greater than start date.", { position: "top-right" });
        updatedForm.toDate = ""; // reset invalid input
      }
    }

    setFormData(updatedForm);

    errors[field] = "";

    // ✅ Clear error when user selects date
    // if (errors[field]) {
    //   setErrors((prev) => {
    //     const newErrors = { ...prev };
    //     delete newErrors[field];
    //     return newErrors;
    //   });
    // }
  };

  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    fieldName: string,
    index?: any
  ) => {
   
    const { name, files } = e.target;
    
    if (files && files.length > 0) {
      const file = files[0];
      const fileName = file.name;
      const docName = fieldName === "firmNgoCoopCoopDetails" ? organizationType : fieldName;
    
    handleUpload(fileName, file, fieldName, formData[fieldName]?.docId, docName);
      // let docId=formData[fieldName]?.docId ?formData[fieldName]?.docId :null;
      // handleUpload(fileName, file, fieldName, formData[fieldName]?.docId);
    }
  };

const validateAPMCSelection = () => {
  const errors = [];
  
  selectedAPMCs.forEach((apmc) => {
    const hasFruits = fruitsSelection[apmc.value] || false;
    const hasOthersChecked = otherInputs[apmc.value] !== undefined && 
                              otherInputs[apmc.value] !== null;
    const hasOthersSelected = hasOthersChecked && 
                              Array.isArray(otherInputs[apmc.value]) && 
                              otherInputs[apmc.value].length > 0;
    
    // OR gate validation: at least one must be selected
    if (!hasFruits && !hasOthersSelected) {
      errors.push(apmc.label);
    }
    
    // ✅ NEW: Check if Others checkbox is checked but no crops selected
    if (hasOthersChecked && !hasOthersSelected) {
      errors.push(`${apmc.label} (Please select at least one crop in Others field)`);
    }
  });
  
  return errors;
};

  const handleUpload = async (
    documentName: string,
    file: any,
    fieldName: string,
    docId?: string | null,
    customDocName?: string
  ) => {
  
    const formData = new FormData();
    formData.append("file", file);
    formData.append("documentName", customDocName || fieldName);
    formData.append("fieldName", fieldName);
    formData.append("applicationId", applicationId);
    // formData.append("schemeId",purpose?.id)

    try {
      setUploadLoading(true)
      const res = await submitContractFarmingFiles(formData, token, docId);
    

      if (res.success == false) {
        toast.error(res?.message, { position: "top-right" });
      } else if (res.success && res.docId) {
        setFormData((prev) => ({
          ...prev,
          [fieldName]: {
            docId: res.docId,
            documentName: customDocName || fieldName,  
            fileName: documentName,
          },
        }));
        errors[fieldName] = "";
        toast.success(res?.message, { position: "top-right" });

      }
    } catch (error) {
      toast.error("File upload failed", { position: "top-right" });
    }finally{
      setUploadLoading(false)
    }
  };

  // Add a "Select All" option dynamically
  const selectAllOption = { value: "all", label: "Select All" };

  

  // const availableAPMCs = useMemo(() => {
  //   if (!apmcData || apmcData.length === 0) return [];
  //  let apmcArray = apmcData.map((item: any) => ({
  //    value: item.id,
  //    label: item.apmcName
  //  }));

  //  return apmcArray;

  // }, [selectedDistricts, APMCsByDistrict]);

  //--------------------------Validation-----------------------
  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};

    // Text inputs
    if (formData.name===null || !formData.name.trim() ) newErrors.name = "Please enter name";
    if (formData.address===null || !formData.address.trim()) newErrors.address = "Please enter address";
    if (formData.phone===null || !formData.phone.trim()) newErrors.phone = "Please enter phone number";

    // Date inputs
    if (!formData.fromDate) newErrors.fromDate = "Please select from date";
    if (!formData.toDate) newErrors.toDate = "Please select to date";

    if (!organizationType || organizationType.trim() === "")
    newErrors.organizationType = "Please select organization type";

     if (!formData.firmNgoCoopCoopDetails && organizationType)
    newErrors.firmNgoCoopCoopDetails = "Please upload registration documents";
  

    // Select fields
    if (selectedDistricts.length === 0)
      newErrors.districts = "Please select at least one district";
    if (selectedAPMCs.length === 0)
      newErrors.apmcs = "Please select at least one APMC";
    // if (selectedIngredients.length === 0)
    //   newErrors.ingredients = "Please select at least one item";

    // File uploads
    if (!formData.solvencyCertificate)
      newErrors.solvencyCertificate = "Please upload solvency certificate";
    // if (!formData.bankGuarantee)
    //   newErrors.bankGuarantee = "Please upload bank guarantee";
    // if (!formData.firmNgoCoopCoopDetails)
    //   newErrors.firmNgoCoopCoopDetails = "Please upload registration documents";
    if (!formData.challanCopy)
      newErrors.challanCopy = "Please upload challan copy";
    if (!formData.licenseProof)
      newErrors.licenseProof = "Please upload licence Proof";
    // if (!formData.e_Hastakshar)
    //   newErrors.e_Hastakshar = "Please upload e-Hastakshar";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

const prepareRegObject = () => {
  const reg = {};
  
  const documentFields = [
    'solvencyCertificate',
    'bankGuarantee',
    'firmNgoCoopCoopDetails',
    'challanCopy',
    'licenseProof',
  ];
  
  documentFields.forEach(field => {
    if (formData[field] && formData[field].docId) {
      reg[field] = {
        type: "document",
        data: {
          docId: formData[field].docId,
          documentName: formData[field].documentName,  // ✅ CORRECT: Use the stored documentName (which contains organization type for firmNgoCoopCoopDetails)
          fileName: formData[field].fileName
        }
      };
    }
     else if (field === 'bankGuarantee') {
      // ✅ For bankGuarantee, always include it even if empty
      reg[field] = {
        type: "document",
        data: {}  // Empty object when no file uploaded
      }; 
    }
  });
  
  return reg;
};

const handleProceedToPayment = async () => {
  // Step 1: Validate APMC selections (OR gate - at least one option per APMC)
  const apmcValidationErrors = validateAPMCSelection();

    if (apmcValidationErrors.length > 0) {
    toast.error(
      `Please select at least one option (Fruits & Vegetables OR Others with crops)`,
      // `Please select at least one option (Fruits & Vegetables OR Others) for: ${apmcValidationErrors.join(', ')}`,
      { position: "top-right" ,autoClose:5000}
    );
    const tableElement = document.querySelector('table');
    if (tableElement) {
      tableElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    return;
  }
  
  // // Step 2: Validate form fields
  if (!validateForm()) {
    toast.error("Please fill all required fields", { position: "top-right" });
    return;
  }

  // Step 3: Prepare the reg object
  const reg = prepareRegObject();

  // Step 4: Prepare the complete payload
  const payload = {
    applicationId: applicationId,
    couchId: couchId,
    textField: {
      Sponsor_Name: formData?.name,
      Sponsor_Address: formData?.address,
      Sponsor_Phone: formData?.phone,
      Sponsor_Reg_From: formData?.fromDate,
      Sponsor_Reg_To: formData?.toDate,
      Sponsor_Reg_Year: formData?.years,
      Sponsor_Dist_Id: selectedDistricts.map(d => ({
        disCode: d.value,
        disName: d.label
      })),
      Registration_Fee: totalFee.toString(),
      Det_Agriculture_Prod: selectedIngredients.map(item => item.label).join(", "),
      commodityData: commodityData,
      Remark: formData?.remarks || "",
      e_Hastakshar:"Yes",
    },
    reg: reg
  };


  const paymentInfo = {
    fruitsFee: fruitsFee,
    othersFee: othersFee,
    totalFee: totalFee,
    selectedOthersCount: selectedOthersCount,
    anyFruitsSelected: anyFruitsSelected,
    selectedAPMCsCount: selectedAPMCs.length
  };
  // Step 5: Make the API call
  try {
    const response = await SponsorRegistration(
      payload,
      applicationId,
      token
    );
    
    if (response.success) {
      toast.success("Form submitted successfully!", { position: "top-right" });
       // Proceed to next step
      statusLvl==="reject" ? setTimeout(()=>{
        navigate("/marketing-board-reg-menu");
      },1000) : onNext(paymentInfo);
    } else {
      toast.error(response.message || "Submission failed", { position: "top-right" });
    }
  } catch (error) {
  
    toast.error(
      error.message || "Failed to submit form. Please try again.",
      { position: "top-right" }
    );
  }
  
  // onNext(paymentInfo);
};

// return {
//   apmcId: apmc.value,
//   district_id: district?.value || null,
//   fruitsAndVeg: fruitsSelection[apmc.value],
//   Others: hasOthers ? otherInputs[apmc.value] : null,
//   Others_Name: hasOthers && otherInputs[apmc.value]?.length > 0
//     ? otherInputs[apmc.value].map(item => item.value).join(", ")
//     : null
// };


const handleCommodity = (e: any, apmc: any) => {
  const { name, checked } = e.target;
  const apmcId = apmc?.other?.id;

  if (name === "fruitsAndVeg") {
    // Update fruitsSelection
    setFruitsSelection((prev) => {
      const updated = { ...prev, [apmcId]: checked };
      
      // Update commodityData based on new fruitsSelection state
      updateCommodityData(apmcId, apmc?.other?.district_id, updated[apmcId], otherInputs[apmcId]);
      
      return updated;
    });
  } else if (name === "Others") {
    // Update otherInputs
    setOtherInputs((prev) => {
      const updated = { ...prev };
      if (checked) {
        updated[apmcId] = updated[apmcId] || [];
      } else {
        delete updated[apmcId];
      }
      
      // Update selectedOthersCount
      setSelectedOthersCount(Object.keys(updated).length);
      
      // Update commodityData based on new otherInputs state
      updateCommodityData(apmcId, apmc?.other?.district_id, fruitsSelection[apmcId], updated[apmcId]);
      
      // Sync with selectedIngredients when unchecking
      syncIngredientsFromOthers(updated);
      
      return updated;
    });
  }
};

// Helper function to update commodityData
const updateCommodityData = (
  apmcId: string,
  districtId: string,
  isFruitsChecked: boolean,
  othersValue: any
) => {
  setCommodityData((prev) => {
    const filtered = prev.filter((item) => item.apmcId !== apmcId);

    const fruitsChecked = isFruitsChecked || false;
    const othersChecked = Array.isArray(othersValue) && othersValue.length > 0;

    if (fruitsChecked || othersChecked) {
      const newData = {
        apmcId: apmcId,
        district_id: districtId,
        fruitsAndVeg: fruitsChecked,
        Others: othersChecked,
       Others_Name:
        othersChecked
          ? othersValue.map((item: any) => item.label)  // use label for name
          : [],
      };
      return [...filtered, newData];
    }

    return filtered;
  });
};


  return (
    <div className="">

          {uploadLoading && (
          <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{background: "rgba(0,0,0,0.3)", zIndex: 1050}}>
            <div className="bg-white p-4 rounded shadow d-flex flex-column align-items-center">
              <div className="spinner-border text-primary mb-3" role="status">
                <span className="visually-hidden">Uploading...</span>
              </div>
              <div className="fw-bold">Uploading, please wait...</div>
            </div>
          </div>
        )}
      <div className="d-flex bg-white p-5 rounded flex-column m-5 text-nightblue justify-content-center">
        <div className="text-center mb-4">
          <h3>FORM - J</h3>
          <h3>[SEE RULE 119(1)]</h3>
          <h3>APPLICATION FOR REGISTRATION AS CONTRACT FARMING</h3>
          <h3>SPONSOR</h3>
        </div>
        <div className="mb-4">
          <p style={{ fontSize: "1.25rem" }} className="text-black">
            To,
          </p>
          <h3 style={{ fontSize: "1.25rem" }} className="text-black mb-3">
            Managing Director
          </h3>
          <h3 style={{ fontSize: "1.25rem" }} className="text-black mb-3">
            Gujarat State Agriculture Marketing Board
          </h3>
          <h3 style={{ fontSize: "1.25rem" }} className="text-black">
            Gandhi Nagar
          </h3>
        </div>
        <div>
          <p style={{ fontSize: "1.25rem" }} className="text-black">
            Sir,
          </p>
          <p style={{ fontSize: "1.25rem" }} className="text-black">
            {" "}
            I/We
            <input
              className={`text-center mx-1 border-0 border-bottom mb-4 ${
                errors.name
                  ? "border-danger bg-danger-subtle border-top border-start border-end"
                  : "border-secondary"
              }`}
              style={{
                width: `${adjustInputWidth(formData.name)}px`,
                minWidth: "200px",
              }}
              value={formData.name}
              
              onChange={(e) => handleInputChange("name", e.target.value)}
              placeholder={errors.name ? `${errors.name}` : "Name"}
              disabled={canOnlyView}
            />
            {/* {errors.name && <span className="text-danger d-block" style={{fontSize: "0.875rem", marginTop: "-10px", marginBottom: "10px"}}>{errors.name}</span>} */}{" "}
            (name)<span className="text-danger">*</span>
            <input
              className={`text-center mx-1 border-0 border-bottom mb-4 ${
                errors.address
                  ? "border-danger bg-danger-subtle border-top border-start border-end"
                  : "border-secondary"
              }`}
              style={{
                width: `${adjustInputWidth(formData.address)}px`,
                minWidth: "200px",
                maxWidth:"100%"
              }}
              value={formData.address}
              onChange={(e) => handleInputChange("address", e.target.value)}
              placeholder={errors.address ? `${errors.address}` : "Address"}
              disabled={canOnlyView}
            />

            {/* CHANGES DONE AS PER THE BUG PDF */}
             {/* <textarea
              rows={1}
              className={` border-0 border-bottom text-center ${
                errors.address
                  ? "border-danger bg-danger-subtle border-top border-start border-end"
                  : "border-secondary"
              }`}
              style={{
                minWidth: "200px",
                maxWidth: "100%",
                // width: "100%",
                resize: "vertical", // allows resizing vertically only
                overflowWrap: "break-word",
                whiteSpace: "pre-wrap",
                lineHeight: "1.5",
              }}
              value={formData.address}
              onChange={(e) => handleInputChange("address", e.target.value)}
              placeholder={errors.address ? `${errors.address}` : "Address"}
              disabled={canOnlyView}
            /> */}
            (address)<span className="text-danger">*</span>
            <input
              type="number"
              className={`text-center mx-1 border-0 border-bottom mb-4 ${
                errors.phone
                  ? "border-danger bg-danger-subtle border-top border-start border-end"
                  : "border-secondary"
              }`}
              style={{
                width: `${adjustInputWidth(formData.phone)}px`,
                minWidth: "200px",
              }}
              min={0}
              value={formData.phone}
              onChange={(e) => {
                let value = e.target.value;

                // ✅ Allow only up to 10 digits
                if (value.length > 10) {
                  value = value.slice(0, 10);
                }

                if (value === "" || Number(value) >= 0) {
                  handleInputChange("phone", value);
                }
              }}
              placeholder={errors.phone ? `${errors.phone}` : "Phone No."}
              disabled={canOnlyView}
            />{" "}
            (phone No.)<span className="text-danger">*</span> am/are making an application for a registration as
            Contract Farming Sponsor for the period from<span className="text-danger">*</span>
            <input
              type="date"
              value={formData.fromDate}
              style={{ width: "135px" }}
              onChange={(e) => handleDateChange("fromDate", e.target.value)}
              className={`text-center border-0 text-center border-bottom border-2 mb-3 rounded-0 mx-2 ${
                errors.fromDate
                  ? "border-danger bg-danger-subtle border-top border-start border-end"
                  : "border-secondary"
              }`}
              disabled={canOnlyView}
            />
            to<span className="text-danger">*</span>
            <input
              type="date"
              value={formData.toDate}
              style={{ width: "135px" }}
              onChange={(e) => handleDateChange("toDate", e.target.value)}
              className={`text-center border-0 text-center border-bottom border-2 mb-3 rounded-0 mx-2 ${
                errors.toDate
                  ? "border-danger bg-danger-subtle border-top border-start border-end"
                  : "border-secondary"
              }`}
              disabled={canOnlyView}
            />
            i.e
            <input
              type="number"
              value={formData.years}
              onChange={(e) => handleInputChange("years", e.target.value)}
              placeholder="Years"
              style={{ width: "100px" }}
              disabled
              className="text-center mx-1 text-center border-0 border-bottom border-secondary mb-4"
            />
            years. I/We want the registration for
            {/* <input className="mx-1 border-0 border-bottom border-secondary mb-4"/>  */}
            <div style={{ display: "inline-block", minWidth: "200px" }}>
              <Select
                isMulti
                options={optionsWithSelectAll}
                value={selectedDistricts}
                onChange={handleDistrictChange}
                placeholder={
                  errors.districts ? errors.districts : "Select District(s)"
                }
                className="mx-2 border-0"
                classNamePrefix="react-select"
                isDisabled={canOnlyView || statusLvl==="reject"}
                styles={{
                  control: (base, state) => ({
                    ...base,
                    backgroundColor:
                      errors.districts &&
                      (!selectedDistricts || selectedDistricts.length === 0)
                        ? "#f8d7da" // light red background
                        : base.backgroundColor,
                    borderColor: errors.districts ? "red" : "grey",
                    "&:hover": {
                      borderColor: errors.districts ? "red" : "",
                    },
                  }),
                }}
              />
            </div>
            district(s)/whole state<span className="text-danger">*</span> and
            <div style={{ display: "inline-block", minWidth: "200px" }}>
              <Select
                isMulti
                options={apmcData}
                value={selectedAPMCs}
                onChange={handleAPMCChange}
                placeholder="Select APMC"
                className="mx-2 border-0"
                isDisabled={canOnlyView || statusLvl==="reject"}
                styles={{
                  control: (base, state) => ({
                    ...base,
                    backgroundColor:
                      errors.apmcs &&
                      (!selectedAPMCs || selectedAPMCs.length === 0)
                        ? "#f8d7da" // light red background
                        : base.backgroundColor,
                    borderColor: errors.apmcs ? "red" : "grey",
                    "&:hover": {
                      borderColor: errors.apmcs ? "red" : "",
                    },
                  }),
                }}
              />
            </div>
            APMC.<span className="text-danger">*</span>
          </p>

          {/* ✅ Dynamic Table */}
          {selectedAPMCs.length > 0 && (
            <div>
              <h3>Choose your registration category in the given table:</h3>
              <table
                className="table table-bordered rounded my-4"
                style={{
                  tableLayout: "fixed",
                  width: "100%",
                  borderCollapse: "collapse",
                  textAlign: "center",
                }}
              >
                <thead>
                  <tr>
                    <th style={{ width: "30%", fontSize: "1.25rem" }}>APMC</th>
                    <th style={{ width: "20%" }}>Fruits & Vegetables<span className="text-danger">*</span></th>
                    <th style={{ width: "50%" }}>Others<span className="text-danger">*</span></th>
                  </tr>
                </thead>
                <tbody>
                  {selectedAPMCs.map((apmc, index) => {
                    const hasFruits = fruitsSelection[apmc.value] || false;
                    const hasOthersChecked = otherInputs[apmc.value] !== null && 
                                              otherInputs[apmc.value] !== undefined;
                    const hasOthersSelected = hasOthersChecked && 
                                              Array.isArray(otherInputs[apmc.value]) && 
                                              otherInputs[apmc.value].length > 0;
                    
                    // ✅ Row is invalid if: no selection OR others checked but empty
                    const isRowInvalid = (!hasFruits && !hasOthersSelected) || 
                                        (hasOthersChecked && !hasOthersSelected);
                    
                    return (
                      <tr 
                        key={apmc.value}
                        style={{
                          backgroundColor: isRowInvalid ? '#fff3cd' : 'transparent'
                        }}
                      >
                        <td style={{ fontSize: "1.25rem" }}>{apmc.label}</td>
                        <td>
                        <div className="d-flex align-items-center justify-content-center">
                          <input
                            type="checkbox"
                            checked={hasFruits}
                            name="fruitsAndVeg"
                            id={`${index}_${apmc?.other?.id}`}
                            onChange={e => handleCommodity(e, apmc)}
                            disabled={canOnlyView || statusLvl==="reject"}
                            style={{ transform: "scale(1.5)", cursor: "pointer" }}
                          />
                        </div>
                        </td>
                        <td style={{ minHeight: "60px", verticalAlign: "middle" }}>
                          <input
                            id={`others_${index}_${apmc?.other?.id}`}
                            type="checkbox"
                            checked={hasOthersChecked}
                            name="Others"
                            disabled={canOnlyView || statusLvl==="reject"}
                            onChange={e => handleCommodity(e, apmc)}
                            style={{ transform: "scale(1.5)", cursor: "pointer" }}
                            className="me-4"
                          />
                          {hasOthersChecked && (
                            <div className="d-inline-block w-75">
                              <Select
                                isMulti
                                options={spicesOptions}
                                value={otherInputs[apmc.value] || []}
                                onChange={(val) => handleOtherSelectChange(apmc, val)}
                                placeholder="Select crops"
                                isDisabled={canOnlyView || statusLvl==="reject"}
                                className={`border-0 border-bottom ${
                                  hasOthersChecked && !hasOthersSelected 
                                    ? 'border-danger' 
                                    : 'border-secondary'
                                } w-100 d-inline-block`}
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    backgroundColor: hasOthersChecked && !hasOthersSelected 
                                      ? '#f8d7da' 
                                      : base.backgroundColor,
                                    borderColor: hasOthersChecked && !hasOthersSelected 
                                      ? 'red' 
                                      : base.borderColor,
                                  }),
                                }}
                              />
                              {/* ✅ Error message below the select */}
                              {hasOthersChecked && !hasOthersSelected && (
                                <div className="text-danger text-start mt-1" style={{ fontSize: "0.875rem" }}>
                                  Please select at least one crop
                                </div>
                              )}
                            </div>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

          {showFeeSummary && (
            <div
              style={{ fontSize: "1.25rem", color: "black" }}
              className="mb-3 border rounded-3 p-3 bg-gray"
            >
              <h3>Fee Summary</h3>
              {/* <div className="bg-secondary my-3" style={{ height: "1px" }}></div> */}
              <div className="border my-3" style={{ height: "1px" }}></div>

              {anyFruitsSelected && (
                <div className="d-flex gap-3 align-items-center justify-content-between mb-2">
                  <p className="m-0">Fruits or Vegetables</p>
                  <p>₹ 500</p>
                </div>
              )}

              {selectedOthersCount > 0 && (
                <div className="d-flex gap-3 align-items-center justify-content-between mb-2">
                  <p className="m-0">Crops Fee (per APMC)</p>
                  <p>
                    ₹ 500 x {selectedOthersCount} = ₹ {othersFee}
                  </p>
                </div>
              )}

              {/* <div className="bg-secondary my-3" style={{ height: "1px" }}></div> */}
              <div className="border my-3" style={{ height: "1px" }}></div>

              <div className="d-flex w-100 justify-content-between">
                <h3>Total Fee</h3>
                <h3>₹ {totalFee}</h3>
              </div>
            </div>
          )}

          <div className="border rounded">
            <p style={{ fontSize: "1.25rem" }} className="text-black p-3">
              Along with this application I am enclosing the following
              documents:
            </p>
            <div
              className="d-flex bg-gray p-2 align-items-center justify-content-between mb-3"
              style={{ fontSize: "1.25rem", color: "black" }}
            >
              <span className="w-75">(1) Solvency certificate<span className="text-danger">*</span></span>
              
                <div>
                  <input
                    type="file"
                    disabled={canOnlyView}
                    name="solvencyCertificate"
                    className="form-control"
                    onChange={(e) => handleFileChange(e, "solvencyCertificate")}
                    accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
                  />
                  {errors && errors.solvencyCertificate && (
                      <span className="text-danger fs-15">
                      {errors.solvencyCertificate}
                    </span>
                  )}
                   {formData?.solvencyCertificate&&<p className="fs-15 mt-2 opacity-75 text-center">Uploaded : {formData?.solvencyCertificate.fileName}</p>}
                </div>
              
            </div>

            <div
              className="d-flex bg-white p-2 align-items-center justify-content-between mb-3 "
              style={{ fontSize: "1.25rem", color: "black" }}
            >
              <span className="w-75">(2) Bank Guarantee<span className="text-danger"></span></span>
              
                <div>
                  <input
                    type="file"
                    disabled={canOnlyView}
                    name="bankGuarantee"
                    className="form-control"
                    onChange={(e) => handleFileChange(e, "bankGuarantee")}
                    accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
                  />
                  {errors && errors.bankGuarantee && (
                    <span className="text-danger fs-15">
                      {errors.bankGuarantee}
                    </span>
                  )}
                      {formData?.bankGuarantee&&<p className="fs-15 mt-2 opacity-75 text-center">Uploaded : {formData?.bankGuarantee.fileName}</p>}
                </div>
              
            </div>

            {/* <div
              className="d-flex bg-gray p-2 align-items-center justify-content-between mb-3 "
              style={{ fontSize: "1.25rem", color: "black" }}
            >
              <span className="w-75">
                (3) Details of Registration Documents of Company/Partnership
                firm/Non-Governmental Organizations/Co-operative
                Society/Government Organization etc. and names and addresses of
                directors and partners, etc.<span className="text-danger">*</span>
              </span>
              
                <div>
                  <input
                    type="file"
                    disabled={canOnlyView}
                    name="firmNgoCoopCoopDetails"
                    className="form-control"
                    onChange={(e) =>
                      handleFileChange(e, "firmNgoCoopCoopDetails")
                    }
                    accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
                  />
                  {errors && errors.firmNgoCoopCoopDetails && (
                    <span className="text-danger fs-15">
                      {errors.firmNgoCoopCoopDetails}
                    </span>
                  )}
                   {formData?.firmNgoCoopCoopDetails&&<p className="fs-15 mt-2 opacity-75 text-center">Uploaded : {formData?.firmNgoCoopCoopDetails.fileName}</p>}
                </div>
              
            </div> */}

            <div
  className="d-flex bg-gray p-2 align-items-center justify-content-between mb-3 "
  style={{ fontSize: "1.25rem", color: "black" }}
>
  <span className="w-50">
    (3) Details of Registration Documents of 
    <span className="text-danger">*</span>
    <div style={{ display: "inline-block", minWidth: "200px" }} className="ms-2">
      <Select
        options={organizationTypeOptions}
        value={organizationTypeOptions.find(opt => opt.value === organizationType)}
        onChange={(selected) => {
          setOrganizationType(selected?.value || "");
          if (errors.organizationType) {
            setErrors((prev) => {
              const newErrors = { ...prev };
              delete newErrors.organizationType;
              return newErrors;
            });
          }
        }}
        placeholder="Select Organization Type"
        className="border-0"
        isDisabled={canOnlyView || statusLvl === "reject"}
        styles={{
          control: (base) => ({
            ...base,
            backgroundColor: errors.organizationType && !organizationType
              ? "#f8d7da"
              : base.backgroundColor,
            borderColor: errors.organizationType ? "red" : "grey",
            "&:hover": {
              borderColor: errors.organizationType ? "red" : "",
            },
          }),
        }}
      />
      {errors.organizationType && (
        <span className="text-danger fs-15 d-block mt-1">
          {errors.organizationType}
        </span>
      )}
    </div>
    and names and addresses of directors and partners, etc.
  </span>
  
  <div>
    <input
      type="file"
      disabled={canOnlyView || !organizationType}
      name="firmNgoCoopCoopDetails"
      className="form-control"
      onChange={(e) =>
        handleFileChange(e, "firmNgoCoopCoopDetails")
      }
      accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
    />
    {errors && errors.firmNgoCoopCoopDetails && (
      <span className="text-danger fs-15">
        {errors.firmNgoCoopCoopDetails}
      </span>
    )}
    {formData?.firmNgoCoopCoopDetails && (
      <p className="fs-15 mt-2 opacity-75 text-center">
        Uploaded : {formData?.firmNgoCoopCoopDetails.fileName}
      </p>
    )}
  </div>
</div>

            <div
              className="d-flex bg-white p-2 align-items-center justify-content-between mb-3 "
              style={{ fontSize: "1.25rem", color: "black" }}
            >
              <span className="w-75">
                (4) Details of agricultural produce coming under the contract.<span className="text-danger">*</span>
              </span>
              {/* <CreatableSelect
                    isMulti
                    options={options}
                    value={selectedValues}
                    onChange={handleChangeInput}
                    onCreateOption={handleCreate}
                    placeholder="Enter Details"
                    name="agriculturalProduceDetails"
                    className="mx-2 border-0 border-bottom border-secondary w-25"
                    isDisabled={isDisabled}
                  /> */}
              <div className="w-25 ps-4 me-2">
                <Select
                  isMulti
                  // options={optionsWithSelectAllinItems}
                  value={selectedIngredients}
                  onChange={handleIngredientsChange}
                  placeholder="Select Items"
                  className="mx-2 w-100 border-0"
                  isDisabled={true}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      backgroundColor:
                        errors.ingredients &&
                        (!selectedIngredients ||
                          selectedIngredients.length === 0)
                          ? "#f8d7da" // light red background
                          : base.backgroundColor,
                      borderColor: errors.ingredients ? "red" : "grey",
                      "&:hover": {
                        borderColor: errors.ingredients ? "red" : "",
                      },
                    }),
                  }}
                />
              </div>
            </div>

            <div
              className="d-flex bg-gray p-2 align-items-center justify-content-between"
              style={{ fontSize: "1.25rem", color: "black" }}
            >
              <span className="w-75">
                (5) Copy of challan under which fee of rupees five hundred per
                year per district has been paid in Government Treasury.<span className="text-danger">*</span>
              </span>
             
                <div>
                  <input
                    type="file"
                    name="challanCopy"
                    disabled={canOnlyView}
                    className="form-control"
                    onChange={(e) => handleFileChange(e, "challanCopy")}
                    accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
                  />
                  {errors && errors.challanCopy && (
                    <span className="text-danger fs-15">
                      {errors.challanCopy}
                    </span>
                  )}
                   {formData?.challanCopy&&<p className="fs-15 mt-2 opacity-75 text-center">Uploaded : {formData?.challanCopy.fileName}</p>}
                </div>
              
            </div>

            <div
              className="d-flex bg-white p-2 align-items-center justify-content-between mb-3 "
              style={{ fontSize: "1.25rem", color: "black" }}
            >
              <span className="w-75">
                (6) Proof of manufacturing, processing, export-import licence.<span className="text-danger">*</span>
              </span>
              <div>
                  <input
                    type="file"
                    name="licenseProof"
                    disabled={canOnlyView}
                    className="form-control"
                    onChange={(e) => handleFileChange(e, "licenseProof")}
                    accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
                  />
                  {errors && errors.licenseProof && (
                    <span className="text-danger fs-15">
                      {errors.licenseProof}
                    </span>
                  )}
                    {formData?.licenseProof&&<p className="fs-15 mt-2 opacity-75 text-center">Uploaded : {formData?.licenseProof.fileName}</p>}
                </div>
              
            </div>
          </div>

          <div className="d-flex justify-content-end mt-5 align-items-end flex-column ">
            
              {/* <div>
                <input
                  type="file"
                  name="e_Hastakshar"
                  className="form-control"
                  onChange={(e) => handleFileChange(e, "e_Hastakshar")}
                  accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
                />
                {errors && errors.e_Hastakshar && (
                  <span className="text-danger fs-15">
                    {errors.e_Hastakshar}
                  </span>
                )}
                   {formData?.e_Hastakshar&&<p className="fs-15 mt-2 opacity-75 text-center">Uploaded : {formData?.e_Hastakshar.fileName}</p>}
              </div>
             */}
            <p
              style={{ fontSize: "1.25rem" }}
              className="text-black py-3 position-relative left-0"
            >
              Signature of Applicant.
            </p>
          </div>
        </div>
      </div>

      {iscommentOpen && (
        <div className="d-flex align-items-center justify-content-between mx-5 mb-5 gap-4">
          <textarea
            className="form-control w-100"
            style={{ fontSize: "1.25rem" }}
            rows={3}
            value={formData.remarks}
            onChange={(e) => handleInputChange("remarks", e.target.value)}
            placeholder="Enter your remarks here."
          />
          <button className="btn btn-info p-3">Submit Comment</button>
        </div>
      )}

      {roleIdentifier === "MBA" && (
        <div
          className="d-flex justify-content-end mb-2 gap-3"
          style={{ position: "absolute", right: "200px" }}
        >
          <button
            className="btn btn-outline-secondary p-3"
            onClick={() => {
              onCommentClick();
            }}
          >
            <i className="feather  feather-message-square me-2"></i>Comment
          </button>
        </div>
      )}

      {roleIdentifier === "SPO" && !canOnlyView && (
        <div className="d-flex justify-content-end mb-3 me-5">
          <button className="btn btn-info " onClick={handleProceedToPayment}>
            {statusLvl==="reject" ? <div>Submit Again</div> : <div>Proceed to Make Payment</div>}
          </button>
        </div>
      )}
    </div>
  );
};

export default SponsorRegistrationP1;
